import DayJs from 'dayjs'
import 'dayjs/locale/en.js'
import 'dayjs/locale/nb.js'
import 'dayjs/locale/sv.js'
import quarterOfYear from 'dayjs/plugin/quarterOfYear.js'
import weekOfYear from 'dayjs/plugin/weekOfYear.js'
import weekday from 'dayjs/plugin/weekday.js'
import { _getDefaultLanguageCode, _getLanguageCode } from '../hooks/useLanguage'

DayJs.extend(quarterOfYear)
DayJs.extend(weekOfYear)
DayJs.extend(weekday)

export const getWeekdayAbbreviation = (date) => {
  const language = _getLanguageCode() || _getDefaultLanguageCode() || 'en'
  const locale = language === 'no' ? 'nb' : language
  const raw = dayjs(date).locale(locale).format('ddd')
  const cleaned = locale === 'sv' || locale === 'nb' ? raw.replace('.', '') : raw
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1)
}

export const dayjs = DayJs
